const prefix = 'local/';

export const CHANGE_LANGUAGE = `${prefix}CHANGE_LANGUAGE`;